// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o2-9";
export var arrowButtonContainer = "_o2-5";
export var arrowButtonIcon = "_o2-6";
export var carouselArrowButton = "_o2-2";
export var carouselElementContainer = "_o2-1";
export var currentSlide = "_o2-8";
export var left = "_o2-3";
export var otherSlide = "_o2-a";
export var productCarouselContainer = "_o2-0";
export var right = "_o2-4";
export var sliderOverflow = "_o2-7";